import { applyMiddleware } from 'redux';

export type Next = (action: any) => any | Promise<any>;

export type ActionHandler = (action: any, next: Next, state: any) => Promise<any>;

const asyncDispatch = (dispatch: Next) => (action: any) => {
    const promise = dispatch(action);
    return promise && promise.then
        ? promise.then((response: any) => response)
        : promise;
};

export function regularThenResponse(response: any, action: any, additionalAction?: any) {
    if (additionalAction != null) {
        additionalAction(response);
    }
    if (action.callback != null) {
        action.callback(response);
    }
    return response;
}

export function regularThenResponseError(action: any, response: any) {
    if (action.callback != null) {
        action.callback(response);
    }
}

export function regularErrorHandling(action: any, error: any) {
    if (action.errorCallback) {
        action.errorCallback(error);
    }
    return error;
}

export function createMiddleware(actionHandlers: { [actionType: string]: ActionHandler }): any {
    const middleware = (state: any) => (next: Next) => (action: any) => {
        if (actionHandlers.hasOwnProperty(action.type)) {
            state.dispatch = asyncDispatch(state.dispatch);
            return actionHandlers[action.type](action, asyncDispatch(next), state).then(response => response);
        }

        return asyncDispatch(next)(action);
    };

    return applyMiddleware(middleware);
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/utils/create-middleware.ts